import { API_URL } from '../../../app-config/constants';
import type { CompanyGlobalHeaderMessageDto } from '../../react/features/Admin/CompanySettings/types';
import { get, put } from '../request';

getGlobalHeaderMessage.operation = 'READ';
export function getGlobalHeaderMessage() {
    return get<CompanyGlobalHeaderMessageDto>(`${API_URL}/company-settings/global-header-message`);
}

setGlobalHeaderMessage.operation = 'COMMAND';
export function setGlobalHeaderMessage(globalHeaderMessage: CompanyGlobalHeaderMessageDto) {
    return put(`${API_URL}/company-settings/global-header-message`, { postData: globalHeaderMessage });
}
